import { Pipe, PipeTransform } from '@angular/core';

import { minutesToTime } from 'app/helpers';

@Pipe({
    name: 'stbyMinutesToTime',
})
export class MinutesToTime implements PipeTransform {
    transform(value: number | string, emitSeconds = false): string {
        if (value === null) {
            return null;
        }

        if (emitSeconds) {
            return minutesToTime(value).split(':').slice(0, 2).join(':');
        }

        return minutesToTime(value);
    }
}
